/**
 * Chatbot API client — wraps Utils/axiosApi (which already attaches the JWT
 * bearer token via interceptor and handles 401 retry). Paths are relative to
 * REACT_APP_BACK_END_API_BASE_URL, which already ends in "/rocon".
 */
import request from "../../Utils/axiosApi";

const BASE = "/chatbot";

export function sendChatMessage({
  message,
  sessionId,
  siteUrl,
  issueSummary,
  userUrgency,
  errorText,
  orgId,
  category,
}) {
  // Build payload omitting null/undefined values to keep the wire tidy.
  // Field names match the intake-form spec (snake_case on the wire).
  const data = { message };
  if (sessionId !== undefined && sessionId !== null) data.session_id = sessionId;
  if (siteUrl !== undefined && siteUrl !== null) data.site_url = siteUrl;
  if (issueSummary !== undefined && issueSummary !== null) {
    data.issue_summary = issueSummary;
  }
  if (userUrgency !== undefined && userUrgency !== null) {
    data.user_urgency = userUrgency;
  }
  if (errorText !== undefined && errorText !== null) data.error_text = errorText;
  if (orgId !== undefined && orgId !== null && orgId !== "") {
    data.org_id = String(orgId);
  }
  if (category !== undefined && category !== null && category !== "") {
    data.category = category;
  }
  return request({
    url: `${BASE}/chat`,
    method: "POST",
    data,
  });
}

export function fetchSessionMessages(sessionId) {
  return request({
    url: `${BASE}/messages`,
    method: "GET",
    params: { session_id: sessionId },
  });
}

export function sendEngineerReply({ sessionId, message, ticketId }) {
  return request({
    url: `${BASE}/engineer-reply`,
    method: "POST",
    data: { session_id: sessionId, message, ticket_id: ticketId },
  });
}

export function fetchMyTickets() {
  return request({ url: `${BASE}/tickets`, method: "GET" });
}
